/* CLZ CART DRAWER v10 — AOV offer banner, no shipping bar */
(function(){
'use strict';

var _flashTimer = null;
var _open = false;

function $$(id){ return document.getElementById(id); }

function fmt(cents){
  var cur = 'INR';
  try{ if(window.Shopify && Shopify.currency && Shopify.currency.active) cur = Shopify.currency.active; }catch(e){}
  try{ return new Intl.NumberFormat('en-IN',{style:'currency',currency:cur,maximumFractionDigits:0}).format(cents/100); }catch(e){ return '\u20b9'+(cents/100).toFixed(0); }
}

function esc(s){
  return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function shopifyImg(raw){
  if(!raw) return null;
  var u = String(raw).replace(/^\/\//,'https://');
  var qi = u.indexOf('?'); if(qi>-1) u=u.slice(0,qi);
  u = u.replace(/_\d+x\d*\./,'.');
  u = u.replace(/(\.(jpe?g|png|webp|gif|jpg))$/i,'_240x$1');
  return u;
}

/* AOV OFFER BANNER */
function clzAovBanner(n){
  var base = 'display:block;padding:12px 16px 12px 20px;background:#111111;border-bottom:1px solid #1e1e1e;position:relative;overflow:hidden;';
  var goldBar = '<div style="position:absolute;left:0;top:0;width:3px;height:100%;background:#eac35f;"></div>';
  if(n >= 5){
    return '<div style="'+base+'" id="clzAovBanner">'+goldBar+
      '<div style="display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:3px;">'+
        '<span style="font-size:14px;">🎉</span>'+
        '<span style="font-family:var(--font-heading-family,sans-serif);font-size:10px;font-weight:700;letter-spacing:.1em;color:#eac35f;text-transform:uppercase;">EXTRA 15% OFF UNLOCKED</span>'+
        '<span style="font-size:14px;">🎉</span>'+
      '</div>'+
      '<p style="margin:0;font-size:11px;color:#b5b5b5;text-align:center;">Your discount is applied at checkout — max savings activated!</p>'+
    '</div>';
  } else if(n >= 2){
    var left = 5 - n;
    var pct = Math.round((n/5)*100);
    return '<div style="'+base+'" id="clzAovBanner">'+goldBar+
      '<div style="margin-bottom:7px;"><span style="display:inline-block;font-family:var(--font-heading-family,sans-serif);font-size:9px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:3px 8px;background:#eac35f;color:#0a0a0a;">✓ EXTRA 10% OFF ACTIVE</span></div>'+
      '<p style="margin:0 0 10px;font-size:12px;color:#e8e8e8;line-height:1.5;">Add <strong style="color:#fff;">'+left+(left===1?' more item':' more items')+'</strong> to unlock <strong style="color:#eac35f;">EXTRA 15% OFF</strong> 🔥</p>'+
      '<div style="width:100%;height:3px;background:#222;overflow:hidden;margin-bottom:5px;"><div style="height:100%;width:'+pct+'%;background:#eac35f;"></div></div>'+
      '<div style="display:flex;justify-content:space-between;">'+
        '<span style="font-family:var(--font-heading-family,sans-serif);font-size:9px;color:#eac35f;text-transform:uppercase;letter-spacing:.04em;">2 items · 10% off</span>'+
        '<span style="font-family:var(--font-heading-family,sans-serif);font-size:9px;color:#b5b5b5;text-transform:uppercase;letter-spacing:.04em;">5 items · 15% off</span>'+
      '</div>'+
    '</div>';
  } else {
    var need = 2 - n;
    var nudge = need <= 1
      ? 'Add <strong style="color:#f0f0f0;">1 more item</strong> to unlock <strong style="color:#eac35f;">EXTRA 10% OFF</strong>!'
      : 'Add <strong style="color:#f0f0f0;">'+need+' more items</strong> to start saving!';
    return '<div style="'+base+'" id="clzAovBanner">'+goldBar+
      '<p style="font-family:var(--font-heading-family,sans-serif);font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#e8e8e8;margin:0 0 10px;">🛍️ ADD MORE, SAVE MORE</p>'+
      '<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">'+
        '<div style="display:flex;align-items:center;gap:7px;flex:1;">'+
          '<div style="width:26px;height:26px;border-radius:50%;border:1.5px solid #b5b5b5;display:flex;align-items:center;justify-content:center;font-family:var(--font-heading-family,sans-serif);font-size:11px;font-weight:700;color:#888;flex-shrink:0;">2</div>'+
          '<div><p style="font-family:var(--font-heading-family,sans-serif);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#f0f0f0;margin:0;line-height:1;">BUY 2</p><p style="font-size:9px;letter-spacing:.04em;text-transform:uppercase;color:#eac35f;margin:1px 0 0;line-height:1;">EXTRA 10% OFF</p></div>'+
        '</div>'+
        '<span style="color:#333;font-size:14px;">→</span>'+
        '<div style="display:flex;align-items:center;gap:7px;flex:1;">'+
          '<div style="width:26px;height:26px;border-radius:50%;border:1.5px solid #eac35f;display:flex;align-items:center;justify-content:center;font-family:var(--font-heading-family,sans-serif);font-size:11px;font-weight:700;color:#eac35f;flex-shrink:0;">5</div>'+
          '<div><p style="font-family:var(--font-heading-family,sans-serif);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#f0f0f0;margin:0;line-height:1;">BUY 5</p><p style="font-size:9px;letter-spacing:.04em;text-transform:uppercase;color:#eac35f;margin:1px 0 0;line-height:1;">EXTRA 15% OFF</p></div>'+
        '</div>'+
      '</div>'+
      '<p style="margin:0;font-size:11px;color:#b5b5b5;padding-top:8px;border-top:1px solid #1a1a1a;">'+nudge+'</p>'+
    '</div>';
  }
}

var clzC = window.clzC = {

  open: function(){
    var bd=$$('clzBd'), pn=$$('clzPn');
    if(!bd||!pn) return;
    bd.style.display='block';
    requestAnimationFrame(function(){ pn.style.transform='translateX(0)'; });
    pn.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    _open=true;
    this.load();
  },

  close: function(){
    var bd=$$('clzBd'), pn=$$('clzPn');
    if(!bd||!pn) return;
    pn.style.transform='translateX(100%)';
    setTimeout(function(){ bd.style.display='none'; },300);
    pn.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    _open=false;
  },

  load: function(cb){
    var items=$$('clzItems');
    if(items) items.innerHTML='<div style="display:flex;align-items:center;justify-content:center;padding:52px 0"><div style="width:20px;height:20px;border:2px solid #1e1e1e;border-top-color:#eac35f;border-radius:50%;animation:clzSpin .6s linear infinite"></div></div>';
    fetch('/cart.js?_='+Date.now(),{credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){ clzC.render(c); if(cb) cb(c); })
      .catch(function(e){ console.error('[CLZ]',e); });
  },

  render: function(cart){
    var n = cart.item_count||0;

    // Badge
    var badge=$$('clzBadge');
    if(badge) badge.textContent=n;
    document.querySelectorAll('[data-clz-bag-count]').forEach(function(e){ e.textContent=n; });

    var rawTotal = cart.total_price||0;
    var originalTotal = cart.original_total_price||rawTotal;
    var totalDiscount = originalTotal - rawTotal;

    var items=$$('clzItems'), foot=$$('clzFoot');
    if(!items) return;

    if(n===0){
      if(foot) foot.style.display='none';
      var savingsBar=$$('clzSavingsBar'); if(savingsBar) savingsBar.style.display='none';
      items.innerHTML=[
        '<div style="display:flex;flex-direction:column;align-items:center;text-align:center;padding:56px 28px 40px">',
          '<div style="font-size:48px;margin-bottom:14px">🛒</div>',
          '<p style="font-family:var(--font-heading-family,sans-serif);font-size:14px;font-weight:700;color:#f0f0f0;margin:0 0 8px">Your bag is empty</p>',
          '<p style="font-size:12px;color:#b5b5b5;margin:0 0 24px;line-height:1.6">Add something you love.</p>',
          '<a href="/collections/all" onclick="clzC.close()" style="display:inline-flex;align-items:center;justify-content:center;height:44px;padding:0 22px;background:#f0f0f0;color:#111;text-decoration:none;font-family:var(--font-heading-family,sans-serif);font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;-webkit-text-fill-color:#111">SHOP ALL →</a>',
        '</div>'
      ].join('');
      return;
    }

    if(foot) foot.style.display='';

    // Discount display
    var discounts = [];
    if(cart.cart_level_discount_applications && cart.cart_level_discount_applications.length){
      cart.cart_level_discount_applications.forEach(function(d){
        var saving = 0;
        if(d.value_type==='percentage') saving=Math.round((originalTotal*parseFloat(d.value))/100);
        else if(d.value_type==='fixed_amount') saving=Math.round(parseFloat(d.value)*100);
        discounts.push({title:d.title,type:d.type,saving:saving,pct:d.value_type==='percentage'?parseFloat(d.value):0});
      });
    }
    var savingsBar=$$('clzSavingsBar');
    var hasAnyDiscount = discounts.length>0 || totalDiscount>0;
    if(savingsBar){
      if(hasAnyDiscount){
        var discHTML='';
        if(discounts.length>0){
          discounts.forEach(function(d){
            var label=d.title||(d.type==='automatic'?'Automatic Discount':'Discount');
            var saving=d.saving>0?d.saving:totalDiscount;
            var pctLabel=d.pct>0?' ('+Math.round(d.pct)+'% off)':'';
            discHTML+=[
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 0">',
                '<div style="display:flex;align-items:center;gap:8px">',
                  '<span style="font-size:14px">🏷️</span>',
                  '<div>',
                    '<p style="font-family:var(--font-heading-family,sans-serif);font-size:10px;font-weight:700;letter-spacing:.08em;color:#eac35f;margin:0;text-transform:uppercase">'+esc(label)+'</p>',
                    pctLabel?'<p style="font-size:10px;color:#b5b5b5;margin:1px 0 0">'+pctLabel+'</p>':'',
                  '</div>',
                '</div>',
                saving>0?'<span style="font-family:var(--font-heading-family,sans-serif);font-size:13px;font-weight:700;color:#4ade80">-'+fmt(saving)+'</span>':'',
              '</div>'
            ].join('');
          });
        } else if(totalDiscount>0){
          discHTML=[
            '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 0">',
              '<div style="display:flex;align-items:center;gap:8px">',
                '<span style="font-size:14px">🎉</span>',
                '<p style="font-family:var(--font-heading-family,sans-serif);font-size:10px;font-weight:700;letter-spacing:.08em;color:#eac35f;margin:0;text-transform:uppercase">DISCOUNT APPLIED</p>',
              '</div>',
              '<span style="font-family:var(--font-heading-family,sans-serif);font-size:13px;font-weight:700;color:#4ade80">-'+fmt(totalDiscount)+'</span>',
            '</div>'
          ].join('');
        }
        savingsBar.innerHTML=discHTML;
        savingsBar.style.display='block';
      } else {
        savingsBar.style.display='none';
      }
    }

    var totalEl=$$('clzTotal');
    if(totalEl) totalEl.textContent=fmt(rawTotal);
    var ctaBtn=$$('clzCheckoutBtn');
    if(ctaBtn) ctaBtn.href='/checkout';

    // Build items list with AOV banner at top
    var html = clzAovBanner(n);
    cart.items.forEach(function(item){
      var src=shopifyImg(item.image);
      var imgHtml=src
        ? '<img src="'+esc(src)+'" alt="'+esc(item.product_title)+'" loading="lazy" style="display:block;width:90px;height:108px;object-fit:cover;background:#161616;flex-shrink:0" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'flex\';">'
          +'<div style="display:none;width:90px;height:108px;background:#161616;flex-shrink:0;align-items:center;justify-content:center;font-size:9px;color:#2a2a2a;text-transform:uppercase;letter-spacing:.1em">PHOTO</div>'
        : '<div style="width:90px;height:108px;background:#161616;display:flex;align-items:center;justify-content:center;font-size:9px;color:#2a2a2a;text-transform:uppercase;letter-spacing:.1em;flex-shrink:0">PHOTO</div>';
      var varHtml=(item.variant_title&&item.variant_title!=='Default Title')
        ? '<p style="font-family:var(--font-heading-family,sans-serif);font-size:9.5px;letter-spacing:.1em;color:#484848;text-transform:uppercase;margin:3px 0 0">'+esc(item.variant_title)+'</p>' : '';
      var itemDiscounted=item.original_line_price&&item.original_line_price>item.final_line_price;
      var priceHtml=itemDiscounted
        ? '<span style="font-family:var(--font-heading-family,sans-serif);font-size:11px;color:#b5b5b5;text-decoration:line-through;display:block">'+fmt(item.original_line_price)+'</span>'
          +'<span style="font-family:var(--font-heading-family,sans-serif);font-size:14px;font-weight:700;color:#eac35f;white-space:nowrap">'+fmt(item.final_line_price)+'</span>'
        : '<span style="font-family:var(--font-heading-family,sans-serif);font-size:14px;font-weight:700;color:#eac35f;white-space:nowrap">'+fmt(item.final_line_price)+'</span>';
      var unitHtml=item.quantity>1?'<p style="font-size:11px;color:#505050;margin:3px 0 0">'+fmt(item.price)+' each</p>':'';
      var k=esc(item.key);
      html+=[
        '<div style="display:grid;grid-template-columns:90px 1fr auto;gap:14px;padding:14px 22px;border-bottom:1px solid #181818;align-items:start">',
          '<a href="'+esc(item.url)+'" onclick="clzC.close()" style="display:block;flex-shrink:0">'+imgHtml+'</a>',
          '<div style="display:flex;flex-direction:column;gap:3px;padding-top:1px">',
            '<p style="font-size:13px;font-weight:500;color:#e8e8e8;line-height:1.35;margin:0">'+esc(item.product_title)+'</p>',
            varHtml,unitHtml,
            '<div style="display:flex;align-items:center;border:1px solid #242424;height:28px;background:#0c0c0c;margin-top:10px;width:fit-content">',
              '<button onclick="clzC.change(\''+k+'\','+( item.quantity-1 )+')" aria-label="Decrease" style="width:28px;height:28px;background:none;border:none;color:#888;font-size:15px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;touch-action:manipulation;padding:0">&#8722;</button>',
              '<span style="width:28px;text-align:center;font-family:var(--font-heading-family,sans-serif);font-size:12px;font-weight:600;color:#f0f0f0;border-left:1px solid #242424;border-right:1px solid #242424;line-height:28px;user-select:none">'+item.quantity+'</span>',
              '<button onclick="clzC.change(\''+k+'\','+( item.quantity+1 )+')" aria-label="Increase" style="width:28px;height:28px;background:none;border:none;color:#888;font-size:15px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;touch-action:manipulation;padding:0">+</button>',
            '</div>',
            '<button onclick="clzC.change(\''+k+'\',0)" style="background:none;border:none;color:#b5b5b5;font-family:var(--font-heading-family,sans-serif);font-size:9px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;text-decoration:underline;text-underline-offset:2px;padding:0;margin-top:6px;text-align:left">Remove</button>',
          '</div>',
          '<div style="display:flex;flex-direction:column;align-items:flex-end;padding-top:1px">'+priceHtml+'</div>',
        '</div>'
      ].join('');
    });
    items.innerHTML=html;
  },

  change: function(key,qty){
    fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(c){ clzC.render(c); })
      .catch(function(e){ console.error('[CLZ change]',e); });
  },

  add: function(varId,qty,btn){
    var orig=btn?btn.textContent:null;
    if(btn){btn.disabled=true;btn.textContent='Adding...';}
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:varId,quantity:qty||1})})
      .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||'Error');}); return r.json(); })
      .then(function(){ if(btn&&orig){btn.disabled=false;btn.textContent=orig;} clzC.open(); clzC.showFlash(); })
      .catch(function(e){ console.error('[CLZ add]',e); if(btn&&orig){btn.disabled=false;btn.textContent=orig;} clzC.open(); });
  },

  showFlash: function(){
    var f=$$('clzFlash');
    if(!f) return;
    f.style.display='flex';
    clearTimeout(_flashTimer);
    _flashTimer=setTimeout(function(){ f.style.display='none'; },3000);
  }
};

(function(){ var s=document.createElement('style'); s.textContent='@keyframes clzSpin{to{transform:rotate(360deg)}}'; document.head.appendChild(s); })();

document.addEventListener('keydown',function(e){ if((e.key==='Escape'||e.key==='Esc')&&_open) clzC.close(); });

(function(){
  var sx=0,sy=0;
  document.addEventListener('touchstart',function(e){ if(!e.target.closest('#clzPn')) return; sx=e.touches[0].clientX; sy=e.touches[0].clientY; },{passive:true});
  document.addEventListener('touchend',function(e){ if(!_open||!e.target.closest('#clzPn')) return; var dx=e.changedTouches[0].clientX-sx; if(dx>70&&Math.abs(e.changedTouches[0].clientY-sy)<50) clzC.close(); },{passive:true});
})();

document.addEventListener('submit',function(e){
  var form=e.target; if(!form) return;
  if((form.getAttribute('action')||'').trim()!=='/cart/add') return;
  if(form.hasAttribute('data-no-drawer')) return;
  e.preventDefault(); e.stopImmediatePropagation();
  var idEl=form.querySelector('[name="id"]'), qtyEl=form.querySelector('[name="quantity"]');
  var btn=form.querySelector('[name="add"]')||form.querySelector('button[type="submit"]');
  if(!idEl||!idEl.value) return;
  clzC.add(parseInt(idEl.value,10),qtyEl?(parseInt(qtyEl.value,10)||1):1,btn);
},true);

document.addEventListener('click',function(e){
  var a=e.target.closest('a'); if(!a) return;
  if((a.getAttribute('href')||'').trim()!=='/cart') return;
  if(a.hasAttribute('data-clz-no-intercept')) return;
  if(a.closest('#clzPn')) return;
  e.preventDefault(); e.stopPropagation(); clzC.open();
},true);

(function(){
  function init(){
    fetch('/cart.js?_='+Date.now(),{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(c){ var n=c.item_count||0; var b=$$('clzBadge'); if(b) b.textContent=n; document.querySelectorAll('[data-clz-bag-count]').forEach(function(e){ e.textContent=n; }); })
      .catch(function(){});
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();

})();
